export const CONSENT_KEY = 'biat-cookie-consent-v1';
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
const ID = 'G-TLPVP8L1QM';
export function readConsent() {
  try {
    const value = JSON.parse(localStorage.getItem(CONSENT_KEY));
    return value && value.version === 1 && typeof value.analytics === 'boolean' && Number.isFinite(value.savedAt) && value.savedAt <= Date.now() && Date.now() - value.savedAt < MAX_AGE ? value : null;
  } catch { return null; }
}
export function clearAnalyticsCookies() {
  const host = window.location.hostname.split('.');
  const domains = [null, ...host.map((_, i) => '.' + host.slice(i).join('.'))];
  document.cookie.split(';').forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (!/^(_ga(?:_|$)|_gid$|_gat(?:_|$))/.test(name)) return;
    domains.forEach(domain => { document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''}`; });
  });
}
export function applyConsent(analytics) {
  window[`ga-disable-${ID}`] = !analytics;
  if (!analytics) { clearAnalyticsCookies(); return; }
  if (document.getElementById('biat-google-analytics')) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  window.gtag('js', new Date());
  window.gtag('config', ID, { allow_google_signals: false, allow_ad_personalization_signals: false });
  const script = document.createElement('script');
  script.id = 'biat-google-analytics'; script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`;
  document.head.appendChild(script);
}
export function saveConsent(analytics) {
  const value = { version: 1, analytics, savedAt: Date.now() };
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(value)); } catch { /* Choice applies to this visit when storage is unavailable. */ }
  const wasLoaded = !!document.getElementById('biat-google-analytics');
  applyConsent(analytics);
  // A fresh document removes an already-loaded tracker after withdrawal.
  if (!analytics && wasLoaded) window.location.reload();
  return value;
}
